/**
 * UTM Parameter Tracking Utility
 * Captures and preserves UTM parameters from ad campaigns
 */

/**
 * Captures UTM parameters from URL and stores them in localStorage
 * @returns {Object|null} UTM data object or null if no UTM params found
 */
export function captureUTMParameters() {
  const params = new URLSearchParams(window.location.search);

  const utmData = {
    source: params.get('utm_source'),
    medium: params.get('utm_medium'),
    campaign: params.get('utm_campaign'),
    term: params.get('utm_term'),
    content: params.get('utm_content'),
    timestamp: new Date().toISOString(),
    landingPage: window.location.pathname
  };

  // Only store if at least utm_source is present
  if (utmData.source) {
    localStorage.setItem('utmData', JSON.stringify(utmData));
    return utmData;
  }

  return null;
}

/**
 * Retrieves stored UTM parameters from localStorage
 * @returns {Object|null} Stored UTM data or null if not found
 */
export function getUTMParameters() {
  const stored = localStorage.getItem('utmData');
  return stored ? JSON.parse(stored) : null;
}

/**
 * Clears stored UTM parameters
 */
export function clearUTMParameters() {
  localStorage.removeItem('utmData');
}

/**
 * Appends stored UTM parameters to a URL
 * @param {string} baseUrl - The base URL to append parameters to
 * @returns {string} URL with UTM parameters appended
 */
export function appendUTMToUrl(baseUrl) {
  const utmData = getUTMParameters();
  if (!utmData) return baseUrl;

  const url = new URL(baseUrl, window.location.origin);

  if (utmData.source) url.searchParams.set('utm_source', utmData.source);
  if (utmData.medium) url.searchParams.set('utm_medium', utmData.medium);
  if (utmData.campaign) url.searchParams.set('utm_campaign', utmData.campaign);
  if (utmData.term) url.searchParams.set('utm_term', utmData.term);
  if (utmData.content) url.searchParams.set('utm_content', utmData.content);

  return url.toString();
}
